/************
 * Margetts *
 ************/

import './margetts/navigation.js';
import './margetts/partials.js';
import './margetts/components/accordion.js';
import axios from 'axios';
import './margetts/components/tabs.js';

/*******
 * PWA *
 *******/
import './pwa';
//Laravel Echo
import Echo from 'laravel-echo'
import Pusher from 'pusher-js';


/***********
 * Setup *
 ***********/

// Axios
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const csrfMetaNode = document.querySelector('meta[name="csrf-token"]');

if (csrfMetaNode) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfMetaNode.getAttribute('content');
}

// Vue
import { createApp } from 'vue';
import mitt from 'mitt';

const emitter = mitt();
window.events = emitter;

// Vue - Messaging
window.flash = function (message, type, duration, dismissable = false) {
    if (message.length) {
        window.events.emit('flash', [message, type, duration, dismissable]);
    }
};

const app = createApp({});

// Vue - Register components
const components = import.meta.glob('./components/**/*.vue', { eager: true });
const registerComponents = (app) => {
    Object.entries(components).forEach(([path, module]) => {
        const componentName = module.default?.name || module.default?.__name || path.split('/').pop().replace('.vue', '');
        app.component(componentName, module.default);
    });
};

registerComponents(app);

// Charts
window.charts = [];

const rerenderCharts = () => {
    setTimeout(() => {
        window.charts.forEach(chart => {
            chart.resize();
        });
    }, 0);
}

if ('orientation' in screen) {
    screen.orientation.addEventListener('change', rerenderCharts);
} else {
    // e.g. Safari
    window.addEventListener('orientationchange', rerenderCharts);
}

window.Pusher = Pusher;
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: import.meta.env.VITE_PUSHER_APP_KEY,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
    forceTLS: true
});

// Vue - Initialise app
app.mount('#app');
